module.exports = __webpack_public_path__ + "static/05-b6d3ed29a8c99b4ab3e655a8548aed6f.jpg";